import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Css/ParaForm.css";
import API_BASE from "../config/api";

const AddParaForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    tagLine: "",
    questionNo: "",
    paragraph: "",
    paragraphImage: null,
  });
  const [explanationImage, setExplanationImage] = useState(null);
  // const [explanation, setExplanation] = useState('');
  const [answerImages, setAnswerImages] = useState([null, null, null, null]);
  const [paragraphType, setParagraphType] = useState("text"); // "text" or "image"
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);

  const [questionData, setQuestionData] = useState({
    question: "",
    questionImage: null,
    answers: ["", "", "", ""],
    answerImages: [null, null, null, null],
    correctIndex: null,
    explanation: "",
  });

  const [softwares, setSoftwares] = useState([]);
  const [standards, setStandards] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [topics, setTopics] = useState([]);
  const [subtopics, setSubtopics] = useState([]);
  const [paperTypes, setPaperTypes] = useState([]);
  const [answerTypes, setAnswerTypes] = useState([]);

  const [selectedSoftware, setSelectedSoftware] = useState("");
  const [selectedStandard, setSelectedStandard] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("");
  const [selectedSubtopic, setSelectedSubtopic] = useState("");
  const [difficulty, setDifficulty] = useState("");

  const handleExplanationImageChange = (file) => {
    setExplanationImage(file);
  };

  useEffect(() => {
    loadSoftwares();
    loadStandards();
    loadEnums();
  }, []);

  const authHeader = {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
    },
  };

  const loadSoftwares = async () => {
    const res = await axios.get(
      `${API_BASE}/api/questions/softwares`,
      authHeader
    );
    setSoftwares(res.data);
  };

  const loadStandards = async () => {
    const res = await axios.get(
      `${API_BASE}/api/questions/standards`,
      authHeader
    );
    setStandards(res.data);
  };

  const loadEnums = async () => {
    const pt = await axios.get(
      `${API_BASE}/api/questions/paper-types`,
      authHeader
    );
    const at = await axios.get(
      `${API_BASE}/api/questions/answer-types`,
      authHeader
    );

    setPaperTypes(pt.data);
    setAnswerTypes(at.data);
  };

  const loadSubjects = async (standardId) => {
    const res = await axios.get(
      `${API_BASE}/api/questions/subjects/${standardId}`,
      authHeader
    );
    setSubjects(res.data);
  };

  /* ------------------- DROPDOWN EVENTS ------------------- */

  const handleSoftwareChange = async (id) => {
    setSelectedSoftware(id);

    const soft = softwares.find((x) => x.id == id);
    if (!soft) return;

    setSelectedStandard(soft.standardId);
    await loadSubjects(soft.standardId);
  };

  const handleStandardChange = async (id) => {
    setSelectedStandard(id);
    await loadSubjects(id);
  };

  const handleSubjectChange = async (id) => {
    setSelectedSubject(id);

    const res = await axios.get(
      `${API_BASE}/api/questions/topics/${id}`,
      authHeader
    );
    setTopics(res.data);
  };

  const handleTopicChange = async (topic) => {
    setSelectedTopic(topic);

    const res = await axios.get(
      `${API_BASE}/api/questions/subtopics?subjectId=${selectedSubject}&topic=${topic}`,
      authHeader
    );
    setSubtopics(res.data);
  };

  /* ------------------- FORM LOGIC ------------------- */

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });

    if (field === "questionNo") {
      const count = parseInt(value);
      setQuestions(new Array(count).fill(null));
      setCurrentQuestionIndex(0);
    }
  };

  const handleInputChange = (field, value) => {
    setQuestionData({ ...questionData, [field]: value });
  };

  const handleAnswerChange = (index, value) => {
    const arr = [...questionData.answers];
    arr[index] = value;
    setQuestionData({ ...questionData, answers: arr });
  };

  const handleAnswerImageChange = (index, file) => {
    const arr = [...questionData.answerImages];
    arr[index] = file;
    setQuestionData({ ...questionData, answerImages: arr });
  };

  const handleQuestionImageChange = (file) => {
    setQuestionData({ ...questionData, questionImage: file });
  };

  /* ------------------- NEXT QUESTION ------------------- */

  const handleNext = () => {
    const updated = [...questions];
    updated[currentQuestionIndex] = { ...questionData };
    setQuestions(updated);

    if (questionData.correctIndex === null) {
      alert("Correct option निवडा");
      return;
    }

    setQuestionData({
      question: "",
      questionImage: null,
      answers: ["", "", "", ""],
      answerImages: [null, null, null, null],
      correctIndex: null,
      explanation: "",
    });

    setCurrentQuestionIndex((prev) => prev + 1);
  };

  /* ------------------- SUBMIT ------------------- */

  const handleSubmit = async () => {
    try {
      const updated = [...questions];
      updated[currentQuestionIndex] = { ...questionData };

      const form = new FormData();

      form.append("SoftwareId", selectedSoftware);
      form.append("SubjectId", selectedSubject);
      form.append("Tagline", formData.tagLine);
      form.append("ParagraphContent", formData.paragraph);

      if (formData.paragraphImage)
        form.append("ParagraphImageUrl", formData.paragraphImage);

      updated.forEach((q, i) => {
        if (!q) return;

        form.append(`Questions[${i}].QuestionText`, q.question);
        form.append(`Questions[${i}].Topic`, selectedTopic);
        form.append(`Questions[${i}].SubTopic`, selectedSubtopic);

        form.append(`Questions[${i}].OptionA`, q.answers[0]);
        form.append(`Questions[${i}].OptionB`, q.answers[1]);
        form.append(`Questions[${i}].OptionC`, q.answers[2]);
        form.append(`Questions[${i}].OptionD`, q.answers[3]);

        form.append(
          `Questions[${i}].CorrectAnswer`,
          ["A", "B", "C", "D"][q.correctIndex]
        );

        form.append(`Questions[${i}].Explanation`, q.explanation || "");
        form.append(`Questions[${i}].DifficultyLevel`, difficulty);
        form.append(`Questions[${i}].Mark`, 2);

        if (q.questionImage)
          form.append(`Questions[${i}].QuestionImage`, q.questionImage);

        q.answerImages.forEach((img, idx) => {
          if (img)
            form.append(
              `Questions[${i}].Option${String.fromCharCode(65 + idx)}Image`,
              img
            );
        });
      });

      await axios.post(
        `${API_BASE}/api/questions/create-paragraph-with-questions`,
        form,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setShowPopup(true);
      navigate('/dashboard/quemanagment')
    } catch (err) {
      console.error(err);
      alert("Save failed");
    }
  };


  return (
    <div className="para-form-container">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          प्रश्न संच   &gt;&gt;प्रश्न मजकूर जोडा  <span> परिच्छेद प्रश्न मजकूर</span>
        </h3>
        <div className="para-form-actions">
          <button
            className="para-cancel-btn"
            disabled={!formData.questionNo || currentQuestionIndex === 0}
            onClick={() => {
              if (currentQuestionIndex > 0) {
                const updated = [...questions];
                updated[currentQuestionIndex] = { ...questionData };
                setQuestions(updated);
                setQuestionData(
                  questions[currentQuestionIndex - 1] || {
                    question: "",
                    questionImage: null,
                    answers: ["", "", "", ""],
                    answerImages: [null, null, null, null],
                    correctIndex: null,
                    explanation: "",
                  }
                );
                setCurrentQuestionIndex((prev) => prev - 1);
              }
            }}
          >
            मागे
          </button>

          <button
            className="para-add-btn"
            disabled={!formData.questionNo}
            onClick={
              currentQuestionIndex < parseInt(formData.questionNo) - 1
                ? handleNext
                : handleSubmit
            }
          >
            {currentQuestionIndex < parseInt(formData.questionNo) - 1
              ? "जतन करा आणि पुढे जा"
              : "सर्व जोडा"}
          </button>
        </div>


      </div>
      <h2>परिच्छेद प्रश्न मजकूर</h2>

      <div className="dropdown-row">
        <div className="dropdown-line">
          <select value={selectedSoftware} onChange={e => handleSoftwareChange(e.target.value)}>
            <option>परीक्षेचे नाव</option>
            {softwares.map(s => (
              <option key={s.id} value={s.id}>{s.softwareName}</option>
            ))}
          </select>

          <select>
            <option>परीक्षा प्रकार</option>
            {paperTypes.map(p => (
              <option key={p.id}>{p.name}</option>
            ))}
          </select>

          <select value={selectedStandard} onChange={e => handleStandardChange(e.target.value)}>
            <option>इयत्ता</option>
            {standards.map(s => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>

          <select value={selectedSubject} onChange={e => handleSubjectChange(e.target.value)}>
            <option>विषय</option>
            {subjects.map(s => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>
        </div>

        <div className="dropdown-line">
          <select className="chapter-select" onChange={e => handleTopicChange(e.target.value)}>
            <option>घटक</option>
            {topics.map(t => (
              <option key={t}>{t}</option>
            ))}
          </select>

          <select className="chapter-select" onChange={e => setSelectedSubtopic(e.target.value)}>
            <option>उपघटक</option>
            {subtopics.map(t => (
              <option key={t}>{t}</option>
            ))}
          </select>

          <select>
            <option>उत्तर निवड प्रकार</option>
            {answerTypes.map(p => (
              <option key={p.id}>{p.name}</option>
            ))}
          </select>

          <select onChange={e => setDifficulty(e.target.value)}>
            <option>प्रश्न पातळी</option>
            <option>Easy</option>
            <option>Moderate</option>
            <option>Difficult</option>
          </select>

        </div>
      </div>


      <div className="para-form-row">
        <div className="para-form-group">
          <label className="para-que-label">टॅगलाईन</label>
          <input
            className="para-input"
            type="text"
            placeholder="इथे टॅगलाईन टाका
"
            value={formData.tagLine}
            onChange={(e) => handleChange("tagLine", e.target.value)}
          />
        </div>

        <div className="para-form-group">
          <label className="para-que-label">एकूण प्रश्न </label>
          <select
            className="para-input"
            value={formData.questionNo}
            onChange={(e) => handleChange("questionNo", e.target.value)}
          >
            <option value="">Select Question No.</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
          </select>
        </div>
      </div>

      <div className="para-form-group">
        <h3 className="para-labele">परिच्छेद प्रकार </h3>
        <div className="para-type-toggle">
          <label>
            <input
              type="radio"
              name="paragraphType"
              value="text"
              checked={paragraphType === "text"}
              onChange={() => setParagraphType("text")}
            />
            Text
          </label>
          <label style={{ marginLeft: "1rem" }}>
            <input
              type="radio"
              name="paragraphType"
              value="image"
              checked={paragraphType === "image"}
              onChange={() => setParagraphType("image")}
            />
            Image
          </label>
        </div>

        {paragraphType === "text" ? (
          <input
            className="para-inputt"
            placeholder="इथे परिच्छेद लिहा"
            value={formData.paragraph}
            onChange={(e) => handleChange("paragraph", e.target.value)}
          />
        ) : (
          <label className="para-image-link">
            Upload Paragraph Image
            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setFormData({ ...formData, paragraphImage: e.target.files[0] })
              }
            />
          </label>
        )}

        {paragraphType === "image" && formData.paragraphImage && (
          <img
            src={URL.createObjectURL(formData.paragraphImage)}
            alt="Paragraph Preview"
            className="para-preview"
          />
        )}
      </div>
      {formData.questionNo &&
        currentQuestionIndex < parseInt(formData.questionNo) && (
          <div className="para-question-block">
            <h3 className="para-labele">प्रश्न {currentQuestionIndex + 1}</h3>
            <div className="para-answer-row">
              <input
                className="para-input"
                placeholder="प्रश्न इथे टाका "
                value={questionData.question}
                onChange={(e) => handleInputChange("question", e.target.value)}
              />
              <label className="para-image-link">
                Add Image
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    handleQuestionImageChange(e.target.files[0])
                  }
                />
              </label>
            </div>

            <label className="para-que-label">उत्तर पर्याय लिहा</label>
            <span className="para-que-label">बरोबर पर्याय चिन्हांकित करा</span>

            {questionData.answers.map((answer, index) => (
              <div className="para-block" key={index}>
                <label className="para-que-label">{`पर्याय 0${index + 1}`}</label>
                <div className="para-row">
                  <input
                    type="checkbox"
                    name="correctAnswer"
                    checked={questionData.correctIndex === index}
                    onChange={() =>
                      handleInputChange("correctIndex", index)
                    }
                    className="para-option-radio"
                  />
                  <div className="answer-row">
                    <input
                      type="text"
                      className="answer-input"
                      placeholder={`पर्याय ०${index + 1} लिहा`}
                      value={answer}
                      onChange={(e) => handleAnswerChange(index, e.target.value)}
                    />

                    <label className="add-image-link">
                      Add Image
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleAnswerImageChange(index, e.target.files[0])}
                      />
                    </label>
                  </div>

                  {questionData.answerImages[index] && (
                    <img
                      src={URL.createObjectURL(questionData.answerImages[index])}
                      alt={`Option ${index + 1}`}
                      className="image-preview"
                    />
                  )}
                </div>
              </div>
            ))}

            <div className="explain">
              <label className="question-label">स्पष्टीकरण</label>

              <div className="explanation-wrapper">
                <textarea
                  className="explanation-input"
                  placeholder="इथे स्पष्टीकरण लिहा"
                  value={questionData.explanation}
                  onChange={(e) =>
                    handleInputChange("explanation", e.target.value)
                  }
                  rows="4"
                />

                <label className="add-image-inside">
                  Add Image
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={(e) =>
                      handleExplanationImageChange(e.target.files[0])
                    }
                  />
                </label>
              </div>

              {explanationImage && (
                <img
                  src={URL.createObjectURL(explanationImage)}
                  alt="Explanation Preview"
                  className="image-preview"
                />
              )}
            </div>
          </div>
        )}

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-boxe">
            <div className="popup-icon">✔</div>

            <h3>प्रश्न यशस्वीरित्या Question Bank मध्ये जोडला गेला आहे..</h3>
            <p>
              आपण हवे असल्यास अजून प्रश्न जोडू शकता किंवा Question Bank पाहू शकता.      </p>

            <div className="popup-actions">
              <button className="outline-btn" onClick={() => navigate('/dashboard/quemanagment')}>
                प्रश्नसंचला जा
              </button>

              <button className="primary-btn" onClick={() => navigate('/dashboard/addqueform')}>
                नवीन प्रश्न जोडा
              </button>
            </div>

            <span className="close-btn" onClick={() => setShowPopup(false)}>✕</span>
          </div>
        </div>
      )}

    </div>
  );
};

export default AddParaForm;